import type { ShallowMutable } from "@mcwd/typescript-type-guards";
import { AnyFormSettingsKey } from "./form-experience/form-settings-keys.js";
import { FormExperienceSettings, FormExperienceSettingsObject } from "./form-experience/form-experience-settings.js";
export * from "./form-experience/form-experience-settings.js";

export interface IGlobalFormSettings {
  readonly recaptchaSiteKey: string,
  readonly baseUrl: string;
  readonly munchkinId: string;
}
export interface IFormSettings extends IGlobalFormSettings, FormExperienceSettings {}

export const MarketoBaseUrl = "https://go.mastercontrol.com" as const;
export const MarketoMunchkinId = "327-YBX-036" as const;
const recaptchaSiteKey = "6LdMUTEiAAAAAN9mxESI45RKRQOrJHvwA4iRAkVS" as const;


type FormSettingsType = {
  [Key in keyof typeof FormExperienceSettingsObject]: {
    recaptchaSiteKey: string;
    baseUrl: string;
    munchkinId: string;
  } & (typeof FormExperienceSettingsObject)[Key]
};

type MutableFormSettingsType = ShallowMutable<FormSettingsType>

export const FormSettingsObject = AnyFormSettingsKey.reduce(
  (
    result: Partial<MutableFormSettingsType>,
    formExperienceKey: AnyFormSettingsKey
  ) => {
    const formExperience = FormExperienceSettingsObject[formExperienceKey];
    (result[formExperienceKey] as FormSettingsType[typeof formExperienceKey]) = Object.freeze({
      recaptchaSiteKey: recaptchaSiteKey,
      baseUrl: MarketoBaseUrl,
      munchkinId: MarketoMunchkinId,
      ...formExperience,
    } as const satisfies FormSettingsType[typeof formExperienceKey]);
    return result;
  },
  {} satisfies Partial<MutableFormSettingsType>
) as FormSettingsType;

export function getFormSettings<TSettings extends typeof FormSettingsObject[AnyFormSettingsKey] | IFormSettings = typeof FormSettingsObject[AnyFormSettingsKey]> (formExperienceKey: AnyFormSettingsKey) {
  if (AnyFormSettingsKey.includes(formExperienceKey) === false) {
    throw new Error(`Couldn't find form experience with key "${formExperienceKey}"`);
  }
  return FormSettingsObject[formExperienceKey] as TSettings;
  // const formExperience = FormExperienceSettingsObject[formExperienceKey];
  // return Object.freeze({
  //   recaptchaSiteKey,
  //   baseUrl: MarketoBaseUrl,
  //   munchkinId: MarketoMunchkinId,
  //   ... formExperience
  // });
}

export function getFormClasses(formExperienceKey: AnyFormSettingsKey) {
  if (AnyFormSettingsKey.includes(formExperienceKey) === false) {
    throw new Error(`Couldn't find form experience with key "${formExperienceKey}"`);
  }
  const formExperience = FormExperienceSettingsObject[formExperienceKey];
  const { marketoFormSettingsKey } = formExperience;
  const modalFormClass = `mcui-modal-${formExperienceKey}-form` as const;
  const formSpecificRootClass = `mc-${formExperienceKey}-form` as const;
  const marketoFormClass = `marketo-${marketoFormSettingsKey}-form` as const;
  return { modalFormClass, formSpecificRootClass, marketoFormClass };
}
